import { useMutation } from "@apollo/client";
import { gql } from "generated-graphql";

import { DOCUMENTS } from "../index";

const QUEUE_EXISTING_DOCUMENT_AI_ENRICHMENT_JOB_MUTATION = gql(`
  mutation QueueDocumentAIEnrichmentJobExisting($tenantId: ID!, $documentIds: [ID!]!) {
    queueDocumentAIEnrichmentJobExisting(input: { tenantId: $tenantId, documentIds: $documentIds, strategy: EXTRACT_ALL_EMBED_ALL }) {
      id
      status
      documents {
        id
        title
        extractionStatus
      }
    }
  }
`);

type RetryDocumentExtractionsInput = {
  onSuccess?: () => void;
};

export function useRetryDocumentExtractions(props?: RetryDocumentExtractionsInput) {
  return useMutation(QUEUE_EXISTING_DOCUMENT_AI_ENRICHMENT_JOB_MUTATION, {
    refetchQueries: [DOCUMENTS],
    onCompleted: () => {
      props?.onSuccess?.();
    },
  });
}
